<!-- Pug Template -->
<template lang="pug">
.Tab__Footer(
  :id='footerId'
  :class='footerClass'
)
  div.contact-us
    a(
      href="https://www.proofpoint.com/us/learn-more/itm-free-demo"
      role="contact-us"
    ) Contact Us
      span.mdi.mdi-chevron-right
    <p>for a sales conversation</p>
  download-PDF-button(
    :pdfUrl="pdfUrl"
    @onDownload="propagatePDFDownload"
  )
</template>

<script>
import DownloadPDFButton from "../components/DownloadPDFButton.vue";
export default {
  name: 'tab-footer',
  components: {
    DownloadPDFButton
  }, 
  props: {
    footerId: {
      type: String,
      default: '',
    },
    footerClass: {
      type: String,
      default: '',
    },
    pdfUrl: {
      type: String,
      default: '',
    }
  },
  methods: {
    setMobile(v){
      this.mobile = v;
    },
    propagatePDFDownload() {
      this.$emit('onPDFDownload')
    }
  }
}
</script>
<!-- SCSS Style -->
<style lang="scss" scoped>
@import '../../scss/base.scss';
.Tab__Footer {
  background-color: #343741;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  @include media-breakpoint-up(lg) {
    padding: 10px 2rem;
  }
  &.hidden {
    display: none;
  }
  .contact-us {
    flex: 1;
    p {
      color: white;
      font-size: 1rem;
      line-height: 1rem;
    }
    a {
      font-family: $headings-font-family;
      font-size: 1.4rem;
      padding-bottom: 4px;
      color: $blue;
    }
  }
}
</style>